import React, { memo, useCallback, useMemo } from 'react';

import Modal from 'components/molecules/modal';
import PdfTronViewer from 'components/organisms/pdfTronViewer';

import { DialogExtension } from '../../molecules/modal/types';
import MultipleButtonExtension from './multipleButtonExtension';
import sm from './styles.module.scss';
import { Props } from './types';
import useFileViewModal from './useFileViewModal';

const FileViewModal = ({
  fileInformation,
  handleFileChange,
  fileId,
  isVisible,
  onCloseClick,
  onUpdateDocument,
  usePrivateViewer,
}: Props) => {
  const {
    handleSetRef,
    closeConfig,
    multipleButtonsProp,
    updateCurrentDocument,
  } = useFileViewModal(
    onCloseClick,
    isVisible,
    fileInformation,
    fileId,
    handleFileChange,
    onUpdateDocument
  );
  const component = useCallback(
    () => (
      <MultipleButtonExtension
        handleNextDocumentClick={multipleButtonsProp.handleNextDocumentClick}
        handlePreviousDocumentClick={
          multipleButtonsProp.handlePreviousDocumentClick
        }
        nextDocumentButtonEnabled={multipleButtonsProp.nextButtonEnabled}
        previousDocumentButtonEnabled={multipleButtonsProp.prevButtonEnabled}
      />
    ),
    [
      multipleButtonsProp.handleNextDocumentClick,
      multipleButtonsProp.handlePreviousDocumentClick,
      multipleButtonsProp.nextButtonEnabled,
      multipleButtonsProp.prevButtonEnabled,
    ]
  );
  const plugin = useMemo<DialogExtension | undefined>(
    () => (fileInformation.length > 1 ? { draw: component } : undefined),
    [component, fileInformation.length]
  );

  return (
    <Modal
      leaveInDom
      closeConfig={closeConfig}
      withoutPadding
      withoutRoundedBorders
      isVisible={isVisible}
      modalClass={sm.OuterModal}
      wrapClasses={sm.ModalWrap}
      dialogExtension={plugin}
    >
      <div
        className={sm.Container}
        style={{ display: isVisible ? undefined : 'none' }}
      >
        {((usePrivateViewer && isVisible) || !usePrivateViewer) && (
          <PdfTronViewer
            docUrl={multipleButtonsProp.url}
            onSetRef={handleSetRef}
            onUpdateDocumentClick={updateCurrentDocument}
            usePrivateViewer={usePrivateViewer}
          />
        )}
      </div>
    </Modal>
  );
};

export default memo(FileViewModal);
